export enum LadingTargetType {
    Employee = 1,
    Partner = 2
}
